import { render, staticRenderFns } from "./TimeslotForm.vue?vue&type=template&id=f8c60e84"
import script from "./TimeslotForm.vue?vue&type=script&lang=js"
export * from "./TimeslotForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports